var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.524,
    height: 24,
    viewBox: "0 0 23.524 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(20229.699 14587.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M450.821,978.652a10.379,10.379,0,0,0-.251-2.452H439.3v4.454h6.616a5.858,5.858,0,0,1-2.452,3.894l-.024.147,3.562,2.76.247.024a11.739,11.739,0,0,0,3.571-8.827",
    transform: "translate(-20656.998 -15554.101)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M224.019,1081.833a11.445,11.445,0,0,0,7.949-2.907l-3.785-2.936a7.093,7.093,0,0,1-4.16,1.2,7.236,7.236,0,0,1-6.83-4.99l-.142.014-3.7,2.865-.047.133a11.964,11.964,0,0,0,10.719,6.621",
    transform: "translate(-20441.719 -15645.548)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M191.47,915.221a7.349,7.349,0,0,1-.4-2.376,7.793,7.793,0,0,1,.389-2.376l0-.156L187.7,907.4l-.123.057a11.975,11.975,0,0,0,0,10.776l3.889-3.012",
    transform: "translate(-20416 -15488.564)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M223.829,773.924a6.621,6.621,0,0,1,4.639,1.788l3.386-3.306a11.54,11.54,0,0,0-8.03-3.121A11.989,11.989,0,0,0,213.1,775.9l3.88,3.012a7.264,7.264,0,0,1,6.849-4.99",
    transform: "translate(-20441.529 -15357)",
    fill: "#eb4335"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.7a307746087fa740fe670bd4fee14347.svg";
export { ForwardRef as ReactComponent };